import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import createIndexedDBStorage from "redux-persist-indexeddb-storage";
import { encryptTransform } from "redux-persist-transform-encrypt";
import sidebarReducer from "./Slice/sidebarSlice";
import loadSliceReducer from "./Slice/loadSlice";
import editloadSliceReducer from "./Slice/EditloadSlice";
import toastReducer from "./Slice/toastSlice";
import userReducer,{UserState} from "./Slice/UserSlice";
import columnFilterReducer,{ColumnFilterState} from './Slice/ColumnFilterSlice'
import locationSliceReducer from './Slice/locationSlice'
import documentsSliceReducer from './Slice/DocumentSlice'
import reportReducer ,{ReportState} from '../store/reports';
import dashboardReducer from './Slice/DashboardSlice';
import superadminReducer from './Slice/SuperadminSlice';
import globalSearchReducer from './Slice/globalSearchSlice';
import loadFilterReducer from './Slice/LoadFilterSlice';
import { resetAppState } from "./actions";
// Import types for proper typing with redux-persist
import { PersistConfig } from 'redux-persist';
import { ILoad, SidebarState } from "@/types";
import { TypedUseSelectorHook,useSelector, useDispatch } from "react-redux";
export const indexedDBStorage = createIndexedDBStorage("myAppDB");
const encryptionTransform = encryptTransform({
  secretKey: import.meta.env.VITE_API_INDEX_DB_STORAGE,
  onError: (error: Error) => {
    console.warn("Encryption error:", error);
  },
});

// Properly typed persist configs
const LoadpersistConfig: PersistConfig<ILoad> = {
  key: "load",
  storage: indexedDBStorage,
  transforms: [encryptionTransform],
  blacklist: ['search',"CarrierLoading","CustomerLoading"]
};

const columnFilterpersistConfig: PersistConfig<ColumnFilterState> = {
  key: "columnFilter",
  storage: indexedDBStorage,
  transforms: [encryptionTransform],
};
const reportFilterpersistConfig: PersistConfig<ReportState> = {
  key: "reportFilter",
  storage: indexedDBStorage,
};


const sidebarpersistConfig: PersistConfig<SidebarState> = {
  key: "sidebar",
  storage: indexedDBStorage,
  transforms: [encryptionTransform],
};
const AuthPersistConfig: PersistConfig<UserState> = {
  key: "company",
  storage: indexedDBStorage,
  transforms: [encryptionTransform],
};
const appReducer = combineReducers({
  sidebar: persistReducer(sidebarpersistConfig, sidebarReducer),
  load: persistReducer(LoadpersistConfig, loadSliceReducer),
  toast: toastReducer,
  editload: editloadSliceReducer,
  user: persistReducer(AuthPersistConfig, userReducer),
  columnFilter: persistReducer(columnFilterpersistConfig, columnFilterReducer),
  location: locationSliceReducer,
  report: persistReducer(reportFilterpersistConfig, reportReducer),
  dashboard: dashboardReducer,
  documents: documentsSliceReducer,
  superadmin: superadminReducer,
  globalSearch: globalSearchReducer,
  loadFilter: loadFilterReducer,
});

export const rootReducer = (state: any, action: any) => {
  if (action.type === resetAppState.type) {
    const user = state?.user;
    const sidebar=state?.sidebar
    state = {
      user, // preserve auth data if desired
      sidebar
    };
  }

  return appReducer(state, action);
};
// Create the store with properly typed reducers
export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
export const persistor = persistStore(store);
export type RootState = ReturnType<typeof store.getState>;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
